import { render, staticRenderFns } from "./projectList.vue?vue&type=template&id=0a2177fe&scoped=true&"
import script from "./projectList.vue?vue&type=script&lang=js&"
export * from "./projectList.vue?vue&type=script&lang=js&"
import style0 from "./projectList.vue?vue&type=style&index=0&id=0a2177fe&prod&lang=css&"
import style1 from "./projectList.vue?vue&type=style&index=1&id=0a2177fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2177fe",
  null
  
)

export default component.exports